import { ComponentWithAs } from '@chakra-ui/react';
import { IIconProps, Icon } from '~/components/Icon';

interface AlphabetIndexIconProps extends IIconProps {
  isActive?: boolean;
}

export const AlphabetIndexIcon: ComponentWithAs<
  'svg',
  AlphabetIndexIconProps
> = ({ isActive, ...props }: any) => (
  <Icon data-testid="alphabet-index-icon" viewBox="0 0 16 16" {...props}>
    {isActive ? (
      // Active/On state
      <path
        d="M10 1C10.2761 1 10.5 1.22386 10.5 1.5V2H11.5C12.3284 2 13 2.67157 13 3.5V13C13 13.8284 12.3284 14.5 11.5 14.5H3.5C2.67157 14.5 2 13.8284 2 13V3.5C2 2.67157 2.67157 2 3.5 2H4.5V1.5C4.5 1.22386 4.72386 1 5 1C5.27614 1 5.5 1.22386 5.5 1.5V2H7V1.5C7 1.22386 7.22386 1 7.5 1C7.77614 1 8 1.22386 8 1.5V2H9.5V1.5C9.5 1.22386 9.72386 1 10 1ZM14.125 10.5C14.3321 10.5 14.5 10.6679 14.5 10.875V12.125C14.5 12.3321 14.3321 12.5 14.125 12.5H13.5V10.5H14.125ZM4.5 9C4.22386 9 4 9.22386 4 9.5C4 9.77614 4.22386 10 4.5 10H10.5C10.7761 10 11 9.77614 11 9.5C11 9.22386 10.7761 9 10.5 9H4.5ZM14.125 7.5C14.3321 7.5 14.5 7.66789 14.5 7.875V9.125C14.5 9.33211 14.3321 9.5 14.125 9.5H13.5V7.5H14.125ZM4.5 7C4.22386 7 4 7.22386 4 7.5C4 7.77614 4.22386 8 4.5 8H10.5C10.7761 8 11 7.77614 11 7.5C11 7.22386 10.7761 7 10.5 7H4.5ZM14.125 4.5C14.3321 4.5 14.5 4.66789 14.5 4.875V6.125C14.5 6.33211 14.3321 6.5 14.125 6.5H13.5V4.5H14.125ZM4.5 5C4.22386 5 4 5.22386 4 5.5C4 5.77614 4.22386 6 4.5 6H10.5C10.7761 6 11 5.77614 11 5.5C11 5.22386 10.7761 5 10.5 5H4.5Z"
        fill="currentColor"
      />
    ) : (
      // Inactive/Off state
      <>
        <path
          d="M13.5 4.5H14.125C14.3321 4.5 14.5 4.66789 14.5 4.875V6.125C14.5 6.33211 14.3321 6.5 14.125 6.5H13.5V4.5Z"
          fill="currentColor"
        />
        <path
          d="M14.125 7.5H13.5V9.5H14.125C14.3321 9.5 14.5 9.33211 14.5 9.125V7.875C14.5 7.66789 14.3321 7.5 14.125 7.5Z"
          fill="currentColor"
        />
        <path
          d="M13.5 10.5H14.125C14.3321 10.5 14.5 10.6679 14.5 10.875V12.125C14.5 12.3321 14.3321 12.5 14.125 12.5H13.5V10.5Z"
          fill="currentColor"
        />
        <rect
          x="2.5"
          y="2.5"
          width="10"
          height="11.5"
          rx="1"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        <path
          d="M5 3.5V1.5"
          stroke="currentColor"
          strokeLinecap="round"
          fill="none"
        />
        <path
          d="M7.5 3.5V1.5"
          stroke="currentColor"
          strokeLinecap="round"
          fill="none"
        />
        <path
          d="M10 3.5V1.5"
          stroke="currentColor"
          strokeLinecap="round"
          fill="none"
        />
        <path
          d="M4.5 5.5H10.5"
          stroke="currentColor"
          strokeLinecap="round"
          fill="none"
        />
        <path
          d="M4.5 7.5H10.5"
          stroke="currentColor"
          strokeLinecap="round"
          fill="none"
        />
        <path
          d="M4.5 9.5H10.5"
          stroke="currentColor"
          strokeLinecap="round"
          fill="none"
        />
      </>
    )}
  </Icon>
);
